import { render } from "./MasterDataKpis.vue?vue&type=template&id=925d95d0"
import script from "./MasterDataKpis.vue?vue&type=script&lang=js"
export * from "./MasterDataKpis.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__